"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getNumericFontValue = _interopRequireDefault(require("./getNumericFontValue"));

var _wrapFontFamilyInQuotes = _interopRequireDefault(require("./wrapFontFamilyInQuotes"));

var getCanvasFontProperty = function getCanvasFontProperty(fontName, fontSize) {
  return "".concat((0, _getNumericFontValue["default"])(fontSize), "px ").concat((0, _wrapFontFamilyInQuotes["default"])(fontName));
};

var _default = getCanvasFontProperty;
exports["default"] = _default;